;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Router = APP.module('Router');

	Router.LeaguesRegeneration = Marionette.AppRouter.extend({
		permissions: {
			'index': 1,
			'settings': 1,
			'invites': 1,
			'confirmation': 1
		},
		appRoutes:{
			'regeneration(/)': 'index',
			'regeneration/:league_id/settings': 'settings',
			'regeneration/:league_id/:regenerated_id/invites': 'invites',
			'regeneration/:league_id/:regenerated_id/confirmation': 'confirmation'
		}
	});

}(window, APP, Backbone, Marionette, $, _));